import app from '@/entries/main';
import LocationsRegionPartnerStores from '@/components/Locations/LocationsRegionPartnerStores.vue';
import LocationsMapDisplay from '@/components/Locations/LocationsMapDisplay.vue';
import LocationCard from '@/components/Locations/subComponents/LocationCard.vue';
import LocationSearchBox from '@/components/Locations/LocationSearchBox.vue';
import GoogleMaps from '@/components/Base/Maps/Locations/GoogleMaps.vue';
import OpeningTimesBlock from '@/components/Locations/subComponents/OpeningTimesBlock.vue';
import CustomerFeedBackSlider from '@/components/Base/Slider/CustomerFeedBackSlider.vue';
app.component('locations-region-partner-stores', LocationsRegionPartnerStores);
app.component('locations-map-display', LocationsMapDisplay);
app.component('location-card', LocationCard);
app.component('location-search-box', LocationSearchBox);
app.component('google-maps', GoogleMaps);
app.component('opening-times-block', OpeningTimesBlock);
app.component('customer-feed-back-slider', CustomerFeedBackSlider);
/** Add Vue Components here */
app.mount('#app');
